import { GlowUpProduct } from '@repo/types/src/glow-up-product';
import { GlowUpProductCard } from './GlowUpProductCard';

interface Props {
  products: GlowUpProduct[];
}

export const GlowUpProductList = ({ products }: Props) => {
  if (products.length === 0) {
    return (
      <p className="text-zinc-400 text-sm">
        Aucun produit pour cette catégorie
      </p>
    );
  }

  return (
    <div className="flex flex-wrap gap-4">
      {products.map((product) => (
        <GlowUpProductCard key={product.id} product={product} />
      ))}
    </div>
  );
};
